import PropTypes from 'prop-types';
import React, {Component} from 'react';
import path from 'path';
import debounce from 'lodash/debounce';

import {events} from 'lib';
import session from 'services/sessionService';

import DealerApi from 'api/dealer';
import PoolApi from 'api/pool';
import ProductApi from 'api/product';
import {mergeSystems} from 'api/dataCleanup';

import {Col, Row, Loader} from 'components';
import {Button, ConfirmationModal} from 'components/layout';
import FullSystemCard from './FullSystemCard';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

class SelectMaster extends Component {
  static propTypes = {
    cancel: PropTypes.func.isRequired,
    customer: PropTypes.object.isRequired,
    first: PropTypes.object.isRequired,
    second: PropTypes.object.isRequired,
    return: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      dealer: {},
      products: [],
      pool1: {},
      pool2: {},
      selected: 0,

      confirmVisible: false,
    };
  }

  componentWillMount() {
    Promise.all([
      DealerApi.getDealer(session.getUser().dealerId),
      ProductApi.getProducts(),
      PoolApi.getPool(this.props.first.id),
      PoolApi.getPool(this.props.second.id),
    ])
      .then(([dealer, products, pool1, pool2]) => {
        this.setState({
          dealer,
          products,
          pool1,
          pool2,
          loaded: true,
        });
      });

    this.confirm = debounce(this.mergeSystems, 500, {leading: true, trailing: false});
  }

  cancelMerge() {
    this.setState({
      confirmVisible: false,
    });
  }

  merge() {
    if (!this.state.selected) {
      events.publish('warn.user', {message: this.props.intl.formatMessage({id: 'encyclopedia.title'})});
      return;
    }
    this.setState({
      confirmVisible: true,
    });
  }

  mergeSystems() {
    let master = this.state.pool1;
    let other = this.state.pool2;
    let {formatMessage} = this.props.intl;

    if (this.state.selected === 2) {
      [master, other] = [other, master];
    }
    mergeSystems(master, other)
      .then((res) => {
        if (res.success) {
          this.setState({
            confirmVisible: false,
          });
          session.deleteCustomer(this.props.customer);
          setTimeout(() => {
            if (this.props.return) {
              events.publish('success.user',
                {
                  message: <span><FormattedMessage id="merge.complete"/> <a className='blue'
                                                                            href='#tools/accounts/multiple-systems/1'>Return to report.</a></span>,
                });
            } else {
              events.publish('success.user', {message: formatMessage({id: 'merge.complete'})});
            }
          }, 500);
          location.hash = path.join(location.hash, '..', '..');
        } else {
          throw new Error(res);
        }
      })
      .catch(err => {
        console.error(err);
        events.publish('error.user', {message: formatMessage({id: 'merge.failed'})});
      });
  }

  select(selected) {
    this.setState({selected});
  }

  render() {
    let {formatMessage} = this.props.intl;
    const {customer} = this.props;

    return <Loader loaded={this.state.loaded}>
      <h3 className='blue'><FormattedMessage id="tools.multiple.select.master"/></h3>
      <p className='semi-bold'><FormattedMessage id="merge.note"/></p>

      <ConfirmationModal
        message={formatMessage({id: 'tools.merge.confirm.merge'})}
        visible={this.state.confirmVisible}
        dismissKey='SYSTEM_MERGE_DISMISS'
        submitLabel={formatMessage({id: 'general.confirm'})}
        onClose={() => this.cancelMerge()}
        onSubmit={() => this.confirm()}/>

      <Row>
        <Col md={6}>
          <FullSystemCard pool={this.state.pool1}
                          dealer={this.state.dealer}
                          products={this.state.products}
                          customer={customer}
                          selected={this.state.selected === 1}
                          onChange={() => this.select(1)}/>
        </Col>
        <Col md={6}>
          <FullSystemCard pool={this.state.pool2}
                          dealer={this.state.dealer}
                          products={this.state.products}
                          customer={customer}
                          selected={this.state.selected === 2}
                          onChange={() => this.select(2)}/>
        </Col>
      </Row>
      <Row style={{marginTop: 20}}>
        <Col md={12}>
          <div className='pull-right'>
            <Button default
                    onClick={this.props.cancel}
                    style={{marginRight: 20}}><FormattedMessage id="general.cancel"/></Button>
            <Button primary
                    disabled={!this.state.selected}
                    onClick={() => this.merge()}><FormattedMessage id="general.merge"/></Button>
          </div>
        </Col>
      </Row>
    </Loader>;
  }
}

export default injectIntl(SelectMaster);
